import { cn } from "../../../lib/cn";
import { useMessage } from "./Context";

export function MessageReaction() {
    const { reaction, sender } = useMessage();

    if (!reaction) {
        return null;
    }

    return (
        <span
            role="img"
            aria-label={`Reacted with ${reaction}`}
            className={cn(
                "pointer-events-none absolute z-10 grid size-32 select-none place-items-center rounded-full bg-surface-default",
                sender === "member" ? "-bottom-12 -left-12" : "-right-12 -bottom-12",
            )}
        >
            <span className="translate-y-px text-[15px] leading-none">{reaction}</span>
        </span>
    );
}
